import { DateCalendar } from '@one-thd/sui-date-pickers';
import React from 'react';
import { useOrderContext } from '../../../../hooks/useContexts';
import { findSlotIdByDay, getDates, } from '../../../../utils/edit-delivery-address/calendar';
export var BodfsDatePicker = function () {
    var _a = useOrderContext(), availableDeliverySlots = _a.availableDeliverySlots, setSelectedDateId = _a.setSelectedDateId, showCalendar = _a.showCalendar, selectedDeliverySlot = _a.selectedDeliverySlot;
    var _b = React.useMemo(function () { return getDates(availableDeliverySlots); }, [availableDeliverySlots]), minDate = _b.minDate, maxDate = _b.maxDate, unavailableDates = _b.unavailableDates;
    return (React.createElement(DateCalendar, { value: showCalendar && selectedDeliverySlot
            ? new Date(selectedDeliverySlot.startDateTime).toISOString()
            : minDate.toISOString(), minDate: minDate, maxDate: maxDate, unavailableDates: unavailableDates, onChange: function (_event, value) {
            setSelectedDateId(findSlotIdByDay(availableDeliverySlots, value));
        } }));
};
